import * as React from 'react';
import { Typography } from 'antd';
const { Text } = Typography;
// import './LabeledDate.scss';
import { ISODate } from 'client/ui/display/date/ISODate';

export interface LabeledDateProps {
  label: string;
  date: string | null | undefined | Date;
  format?: string;
}

export function LabeledDate(props: LabeledDateProps) {
  return (
    <div className="labeled-date">
      <Text type="secondary">{props.label}: </Text>
      <Text strong>
        <ISODate date={props.date} format={props.format} />
      </Text>
    </div>
  );
}
